import React, { useEffect, useState } from 'react';
import { api } from '../../../app/Api/ApiSlice';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loader from '../../../components/Loader';
import InfiniteScroll from 'react-infinite-scroll-component';
import SuggestedStoreBranchCard from '../../../components/SuggestedStoreBranchCard';
import { FaSearch } from 'react-icons/fa';

const SuggestedStoreBranches = () => {
    const [suggestedBranches, setSuggestedBranches] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [searchedTerm, setSearchedTerm] = useState("")

    const { name } = useParams();

    useEffect(() => {
        const getSuggestedBranches = async () => {
            try {
                setIsLoading(true);
                const response = await api.get(`/stores/${name}/manage/branches/suggesteds`, {
                    params: { page },
                });


                const newBranches = response.data;

                setSuggestedBranches((prev) =>
                    page === 1 ? newBranches : [...prev, ...newBranches]
                );

                // If fewer items are returned than expected, assume no more pages
                if (newBranches.length === 0 || newBranches.length < 10) {
                    setHasMore(false);
                }
            } catch (error) {
                console.log(error)
                toast.error(error?.response?.data?.message || 'Something went wrong');
                setHasMore(false);
            } finally {
                setIsLoading(false);
            }
        };

        getSuggestedBranches();
    }, [page, name]);

    const handleRefresh = async () => {
        setPage(1);
        setHasMore(true);
    };

    return (
        <div>
            <h2 className='page-header-title'>Businesses you can add as branches</h2>
            <div className="search-orgs">
                <input
                    type="search"
                    className='org-search'
                    onChange={(e) => setSearchedTerm(e.target.value)}
                />
                <button><FaSearch /></button>
            </div>
            <InfiniteScroll
                dataLength={suggestedBranches?.length}
                next={() => setPage((prev) => prev + 1)}
                hasMore={hasMore}
                refreshFunction={handleRefresh}
                pullDownToRefresh
                pullDownToRefreshThreshold={50}
                pullDownToRefreshContent={
                    <h4 style={{ textAlign: 'center' }}>↓ Pull down to refresh</h4>
                }
                releaseToRefreshContent={
                    <h4 style={{ textAlign: 'center' }}>↑ Release to refresh</h4>
                }
                loader={<Loader />}
            >
                {suggestedBranches?.length > 0 ? (
                    suggestedBranches.map((b) => (
                        <div className="add-branch-container" key={b.id}>
                            <SuggestedStoreBranchCard b={b} />
                        </div>
                    ))
                ) : (
                    !isLoading && <p className='not-found-msg'>Add Branches</p>
                )}
            </InfiniteScroll>
        </div>
    );
};

export default SuggestedStoreBranches;
